// Generated by Melange

import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as MelNumeral from "../../../../../packages/util/lib/MelNumeral.js";
import * as JsxRuntime from "react/jsx-runtime";

const _map = {"default":"default","text":"text"};

function tToJs(param) {
  return param;
}

function tFromJs(param) {
  return _map[param];
}

function symbol(currency, unit) {
  switch (currency) {
    case /* CURRENCY_UNSPECIFIED */ 0 :
      return "Валюта";
    case /* KZT */ 57 :
      if (unit === "text") {
        return "KZT";
      } else {
        return "₸";
      }
    case /* KGS */ 63 :
      return "KGS";
    case /* UZS */ 125 :
      return "UZS";
    default:
      return "₸";
  }
}

function CurrencyView(Props) {
  let className = Props.className;
  let unitOpt = Props.unit;
  let currencyOpt = Props.currency;
  let amount = Props.amount;
  const unit = unitOpt !== undefined ? unitOpt : "default";
  const currency = currencyOpt !== undefined ? currencyOpt : /* KZT */ 57;
  const money = MelNumeral.format({
    NAME: "Float",
    VAL: amount
  });
  const symbol$1 = symbol(currency, unit);
  const className$1 = Cn.fromList({
    hd: "whitespace-nowrap",
    tl: {
      hd: Cn.take(className),
      tl: /* [] */ 0
    }
  });
  return JsxRuntime.jsx("span", {
    children: money + (" " + symbol$1),
    className: className$1
  });
}

const make = CurrencyView;

export {
  tToJs,
  tFromJs,
  symbol,
  make,
}
/* MelNumeral Not a pure module */
